/**
 * Service layer — Practice Performance AI coaching (CT-025 Phase 4).
 *
 * Thin client over /api/practice-chat (manager-gated). The dashboard computes the firm model for its
 * charts; we hand that same context to Claude for a plain-language read (insights) and follow-up Q&A
 * (chat). No data is fetched here — the context is passed in by the caller.
 */

async function call(body) {
  const token = (typeof window !== 'undefined' && window.__clerkGetToken) ? await window.__clerkGetToken() : null
  const res = await fetch('/api/practice-chat', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`)
  return data
}

/**
 * One call returns the dashboard read: { headline, coaching, notes:{ <sectionId>: text } }.
 * `sections` is the list of section ids you want a one-line note for (must match the keys you render).
 */
export function getPracticeInsights(context, sections) {
  return call({ mode: 'insights', context, sections: sections || [] })
}

/** Conversational follow-up. `messages` is the running [{role,content}] transcript. → { reply }. */
export function chatAboutPractice(context, messages) {
  return call({ mode: 'chat', context, messages })
}
